module.exports = __webpack_public_path__ + "static/img/noPurchase.14c02b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/noPurchase.png
// module id = 8oi2
// module chunks = 1